import { ReactElement, useContext } from 'react';
import { Image, ThemeProvider } from '@volkswagen-onehub/components-core';
import { getGiveawayAssets, GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';
import { useTranslation } from 'react-i18next';
import { GiveawayContext } from '@/state/state';
import styled from 'styled-components';

const StyledImage = styled(Image)`
  border-radius: 0;
`;

const ImageWrapper = styled.div<{ hasOverlay?: boolean }>`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: ${({ hasOverlay, theme }) =>
      hasOverlay
        ? `linear-gradient(to top, ${theme.colors.overlay.enhanced}, transparent)`
        : 'none'};
    pointer-events: none;
  }
`;

const firstAsset = (assets: string[]): string | undefined => {
  if (!assets || assets.length === 0) {
    return undefined;
  }
  return assets[0];
};

export const BeautyShot = ({
  hasOverlay = false,
}: {
  hasOverlay?: boolean;
}): ReactElement | null => {
  const { t } = useTranslation();
  const giveawayData: GiveawayResponse = useContext(GiveawayContext);

  const beautyShotLink =
    firstAsset(getGiveawayAssets(giveawayData, 'beauty-shot')) ??
    firstAsset(getGiveawayAssets(giveawayData, 'exterior'));

  if (!beautyShotLink) {
    return null;
  }

  return (
    <ThemeProvider theme="main">
      <ImageWrapper hasOverlay={hasOverlay}>
        <StyledImage
          src={beautyShotLink}
          alt={t('body.details.beautyShot.title')}
          data-testid="beautyshot-image"
          tabIndex={0}
        />
      </ImageWrapper>
    </ThemeProvider>
  );
};
